import { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { get } from 'core/libs/lodash';
import color from 'core/libs/color';

import MarkdownWrapper from 'core/components/MarkdownWrapper';
import SmartArrow from 'core/components/Icon/SmartArrow';

import styles from './index.styl';


/**
 *
 * @author Alexander Bunin <al.bunin@rambler-co.ru>
 */

export class Spoiler extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpened: false };
  }

  toggleSpoiler = () => {
    const { onToggle } = this.props;
    this.setState(
      ({ isOpened }) => ({ isOpened: !isOpened }),
      () => {
        if (typeof onToggle === 'function') onToggle(this.state.isOpened);
      }
    );
  };

  render() {
    const {
      block,
      parentProps: {
        theme: {
          controls: {
            vikontSpoiler: {
              const: {
                borderColor,
              },
              block: {
                outerIndent,
                innerIndent,
                interitemSpacing,
                unbordered,
                background,
                borderRadius,
              },
              title: {
                font,
                color: titleColor,
              },
              body: {
                padding: bodyPadding,
                font: bodyFont,
              },
              icons: {
                arrowRegularSharp: ArrowRegularSharp,
              },
            },
          },
        },
      },
    } = this.props;

    const body = get(block, 'attributes.body');
    const title = get(block, 'attributes.title');

    const { isOpened } = this.state;

    return (
      <div
        className={cx(
          styles.spoiler,
          isOpened && styles._isOpened,
          !unbordered && styles._isBordered,
        )}
      >
        <style jsx>{`
          .${styles.spoiler}
            margin ${outerIndent}
            border-color ${borderColor}
            background ${background}
            border-radius ${borderRadius}

          .${styles.title}
            color ${titleColor}
            border-color ${borderColor}
            font ${font}
            padding ${innerIndent}

            &:hover
              color ${color(titleColor).alpha(0.9).string()}

          .${styles.content}
            font ${bodyFont}

            .${styles._isOpened} &
              padding ${bodyPadding}
        `}</style>
        <div onClick={this.toggleSpoiler} className={styles.title}>
          {title}
          <div className={styles.arrow}>
            <SmartArrow icon={ArrowRegularSharp} direction='down' />
          </div>
        </div>
        <div className={styles.content}>
          <MarkdownWrapper className={styles.body} interitemSpacing={interitemSpacing}>
            {body}
          </MarkdownWrapper>
        </div>
      </div>
    );
  }
}


Spoiler.propTypes = {
  block: PropTypes.object,
  /**
   * Можно получить и обработать текущее состояние спойлера
   */
  onToggle: PropTypes.func,
  parentProps: PropTypes.object,
  ctx: PropTypes.object,
};

const SpoilerComponent = (block, parentProps, ctx, onToggle) => <Spoiler {...{ block, parentProps, ctx, onToggle }} />;

export default SpoilerComponent;
